import React from 'react';

const ConditionalFragment = ({ condition, children }) => {
  return <React.Fragment>{condition ? <React.Fragment>{children}</React.Fragment> : null}</React.Fragment>;
};

export default ConditionalFragment;
